import PropTypes from "prop-types";
import React from "react";

import { Button } from "../Button";
import { Card } from "../Card";
import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";
import { pluralizeWord } from "../../utils/languageGrammarUtils";

import { buildErrorMessages } from "./utils";

import "./styles.scss";

export const InsuranceEligibilityRecord = ({
  allowRetry,
  carrier,
  className,
  copay,
  downloadResponseButtonOnClick,
  errors,
  insuranceType,
  numberOfAttempts,
  plan,
  rawResponseKey,
  retryButtonOnClick,
  showDownloadRawResponse,
  status,
  statusDefinition,
  timestamp,
  transactionId,
  ...props
}) => (
  <div>
    <Card className={createClassNameString(["insurance-eligibility-status-card", className])}>
      <div>
        <span>
          <span className="tw:font-bold">Insurance Company:</span> {carrier}
        </span>
      </div>
      <div>
        <span>
          <span className="tw:font-bold">Plan:</span> {plan}
        </span>
      </div>
      <div>
        <span {...getAutomationDataAttr("InsuranceEligibilityRecordStatus")}>
          <span className="tw:font-bold">Eligibility:</span> {insuranceType}: {status}{" "}
          {timestamp ? "- " : ""}
          {timestamp}
        </span>
      </div>
      <div>
        <span>
          <span className="tw:font-bold">Definition:</span> {statusDefinition}
        </span>
      </div>
      {copay !== null && copay !== undefined ? (
        <div>
          <span>
            <span className="tw:font-bold">Copay:</span> {copay}
          </span>
        </div>
      ) : (
        <></>
      )}
      <div>
        <span>
          <span className="tw:font-bold">No. of Attempts:</span> {numberOfAttempts}
        </span>
      </div>
      <div>
        <span>
          <span className="tw:font-bold">Control Number:</span> {transactionId}
        </span>
      </div>
      {Array.isArray(errors) && errors.length > 0 && (
        <span>
          <span className="tw:font-bold">{pluralizeWord(errors, "Error")}:</span>
          <uL className="errors-list">
            {buildErrorMessages(errors).map((message) => {
              return (
                <li className="error" key={message}>
                  {message}
                </li>
              );
            })}
          </uL>
        </span>
      )}
      <div className="d-flex justify-content-end">
        {allowRetry && status === "Pending" && (
          <Button
            buttonType="primary"
            onClick={retryButtonOnClick}
            {...getAutomationDataAttr("RetryEligibilityCheckButton")}
          >
            Retry Eligibility Check
          </Button>
        )}
        {showDownloadRawResponse && rawResponseKey && (
          <Button
            buttonType="secondary"
            onClick={downloadResponseButtonOnClick}
            {...getAutomationDataAttr("DownloadRawResponseButton")}
          >
            Download Raw Response
          </Button>
        )}
      </div>
    </Card>
  </div>
);

InsuranceEligibilityRecord.propTypes = {
  allowRetry: PropTypes.bool.isRequired,
  carrier: PropTypes.string.isRequired,
  className: PropTypes.string,
  copay: PropTypes.number,
  downloadResponseButtonOnClick: PropTypes.func,
  errors: PropTypes.array,
  insuranceType: PropTypes.string.isRequired,
  isAso: PropTypes.bool,
  numberOfAttempts: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  plan: PropTypes.string,
  rawResponseKey: PropTypes.string,
  retryButtonOnClick: PropTypes.func,
  showDownloadRawResponse: PropTypes.bool,
  status: PropTypes.string.isRequired,
  statusDefinition: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
  transactionId: PropTypes.string.isRequired,
};

InsuranceEligibilityRecord.defaultProps = {
  allowRetry: false,
  carrier: "",
  className: undefined,
  copay: null,
  downloadResponseButtonOnClick: () => {},
  errors: [],
  insuranceType: "Primary",
  isAso: false,
  numberOfAttempts: "",
  plan: "",
  rawResponseKey: "",
  retryButtonOnClick: () => {},
  showDownloadRawResponse: false,
  status: "",
  statusDefinition: "",
  timestamp: "",
  transactionId: "",
};
